import React from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    ColorPicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffCollectStatesNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formKey, setFormKey] = useState(null);
    const [formTitle, setFormTitle] = useState(null);
    const [formColor, setFormColor] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-collect-states-new/save-data', {
            key: formKey,
            title: formTitle,
            color: formColor,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد وضعیت</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'کلید یکتا'} value={formKey} onChange={setFormKey} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <ColorPicker label={'رنگ'} value={formColor} onChange={setFormColor} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
